import { render } from "./SelfRegistration.vue?vue&type=template&id=00b0faa8&scoped=true"
import script from "./SelfRegistration.vue?vue&type=script&lang=js"
export * from "./SelfRegistration.vue?vue&type=script&lang=js"

import "./SelfRegistration.vue?vue&type=style&index=0&id=00b0faa8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00b0faa8"],['__file',"src/views/UserManagement/SelfRegistration/SelfRegistration.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "00b0faa8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('00b0faa8', __exports__)) {
    api.reload('00b0faa8', __exports__)
  }
  
  module.hot.accept("./SelfRegistration.vue?vue&type=template&id=00b0faa8&scoped=true", () => {
    api.rerender('00b0faa8', render)
  })

}


export default __exports__